var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMovers = function SvgMovers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.146 8.354a.5.5 0 1 0 .708-.708zM3.354 5.146a.5.5 0 1 0-.708.708zM3 5a.5.5 0 0 0 0 1zm10 1a.5.5 0 0 0 0-1zM2.646 5.146a.5.5 0 1 0 .708.708zm3.208-1.792a.5.5 0 1 0-.708-.708zm5 4.292a.5.5 0 0 0-.708.708zm1.792 3.208a.5.5 0 0 0 .708-.708zM13 11a.5.5 0 0 0 0-1zM3 10a.5.5 0 0 0 0 1zm10.354.854a.5.5 0 0 0-.708-.708zm-3.208 1.792a.5.5 0 0 0 .708.708zm-4.292-5-2.5-2.5-.708.708 2.5 2.5zM3 6h10V5H3zm.354-.146 2.5-2.5-.708-.708-2.5 2.5zm6.792 2.5 2.5 2.5.708-.708-2.5-2.5zM13 10H3v1h10zm-.354.146-2.5 2.5.708.708 2.5-2.5z"
  })));
};
export { SvgMovers as ReactComponent };
export default __webpack_public_path__ + "ee050f33a82c8017f7b54d6560fe568a.svg";